import { motion } from 'motion/react'
import { customerMotionTransition } from '../customer-area'
import { HelpCircleIcon } from './dashboardShared'
import type { CustomerOrder } from '../../customerOrdersApi'

type DashboardTrackingActionsProps = {
  selectedOrder: CustomerOrder
  reducedMotion: boolean
  isItalian: boolean
  onOpenOrderDetail: (orderId: string) => void
  onOpenCatalog: () => void
  onRequestSupport: (order: CustomerOrder) => void
}

export const DashboardTrackingActions = ({
  selectedOrder,
  reducedMotion,
  isItalian,
  onOpenOrderDetail,
  onOpenCatalog,
  onRequestSupport,
}: DashboardTrackingActionsProps) => (
  <div className="mt-2 flex flex-wrap items-center gap-2.5 border-t border-(--color-border-default) pt-4">
    <motion.button
      type="button"
      onClick={() => onOpenOrderDetail(selectedOrder.id)}
      whileTap={reducedMotion ? undefined : { scale: 0.985 }}
      transition={customerMotionTransition}
      className="ca-btn-primary inline-flex h-9 items-center px-3 text-sm font-semibold"
    >
      {isItalian ? 'Vedi dettaglio ordine' : 'Open order detail'}
    </motion.button>
    {selectedOrder.status === 'shipped' && selectedOrder.trackingUrl ? (
      <motion.a
        href={selectedOrder.trackingUrl}
        target="_blank"
        rel="noreferrer"
        whileTap={reducedMotion ? undefined : { scale: 0.985 }}
        transition={customerMotionTransition}
        className="ca-btn-secondary inline-flex h-9 items-center border-(--color-status-info-border) text-(--color-status-info) hover:border-(--color-status-info-border) hover:bg-(--color-status-info-bg) px-3 text-sm font-semibold"
      >
        {isItalian ? 'Traccia spedizione' : 'Track shipment'}
      </motion.a>
    ) : null}
    {selectedOrder.status !== 'cancelled' ? (
      <motion.button
        type="button"
        onClick={onOpenCatalog}
        whileTap={reducedMotion ? undefined : { scale: 0.985 }}
        transition={customerMotionTransition}
        className="ca-btn-secondary inline-flex h-9 items-center px-3 text-sm font-semibold"
      >
        {isItalian ? 'Compra di nuovo' : 'Buy again'}
      </motion.button>
    ) : null}
    <motion.button
      type="button"
      onClick={() => onRequestSupport(selectedOrder)}
      whileTap={reducedMotion ? undefined : { scale: 0.985 }}
      transition={customerMotionTransition}
      className="ca-btn-tertiary inline-flex h-9 items-center gap-1 px-2.5 text-sm font-medium hover:underline hover:underline-offset-4"
    >
      <HelpCircleIcon className="h-4 w-4" />
      {isItalian ? 'Richiedi supporto' : 'Request support'}
    </motion.button>
  </div>
)
